import React from 'react'

import Video from '../../components/VideoComponent/VideoComponent'
import useMediaQuery from '../../hooks/useMediaQuery'
import { SectionContainer } from '../../layouts'
import {
  headercontainer,
  justifyContent,
  videoContainer,
} from './CategoryContent.module.css'

const CategoryContent = ({ slice }) => {
  const {
    categorycontentbackground,
    categorycontentheading,
    categorycontenttext,
    categorycontentvideolink,
  } = slice

  const isDesktop = useMediaQuery('(min-width:768px)')

  return (
    <SectionContainer
      backGround={categorycontentbackground}
      extraContentClassName={justifyContent}
      extraHeaderClassName={headercontainer}
      heading={categorycontentheading}
      renderedContent={categorycontenttext}
      withHeader
    >
      {categorycontentvideolink && (
        <Video
          autoplay={isDesktop ? '0' : '1'}
          className={videoContainer}
          videoID={categorycontentvideolink.url.split('=')[1]}
        />
      )}
    </SectionContainer>
  )
}

export default CategoryContent
